import { List, Record } from 'immutable';
class PropertiesMetaRecord extends Record({
  loading: false,
  funnelOptions: List(),
  productInterestOptions: List(),
  tierFitOptions: List()
}, 'PropertiesMetaRecord') {}
export default PropertiesMetaRecord;